const clientQuery = () => {
  return `client {
        clientId
        name
        groups
        resources
        banner
        hasTerms
        logo
        favicon
        haikomUrl
      }`
}

const userQuery = () => {
  return `user {
    id
    firstname
    lastname
    email,
    locale,
    group {
      name
      access
      shared
    }
    modules {
      name
      module
    }
  }`
}

const targetQuery = () => {
  return `targets {
    id
    name,
    limit
  }`
}

export const flattenNodeQuery = () => {
  return `
     nodesFlatten {
       id
       name
       parent
       paths
     }
  `
}

const orderItemsQuery = () => {
  return `orderItems {
    id
    target {
      name
      width
      dpi
      hasLimit
    }
    source{
      id
      name
      thumbnail
      restriction
      waitAttestAt
      deletedAt
      rejectedAt
      failedAt
      metaData {
        ratio {
          width
          height
        }
      }
    }
    destination {
      relativePath
    }
  }`
}

const orderInfoQuery = () => {
  return `orders {
    id
    unit
    ${orderItemsQuery()}
  }`
}

const orderHistoryQuery = () => {
  return `orders {
    id
    createdAt
    processedAt
    deletedAt
    status
    compressedFile
    user {
      email
      firstname
      lastname
    }
    destination {
      message
      receivers
    }
  }`
}

export const bootstrapQuery = () => {
  return `{
    ${clientQuery()}
    ${userQuery()}
    ${targetQuery()}
    ${flattenNodeQuery()}
  }`
}

export const getAllNodes = () => {
  return `{
    ${flattenNodeQuery()}
  }`
}

export const orderQuery = ({
  status,
  skip,
  limit,
  withInfo,
  withAssignedTo,
  withHistory,
  withSharedUUID,
  count = true
}) => {
  return `{
      orders(status: ${status}, skip: ${skip}, limit: ${limit}
        ${withAssignedTo ? `, assignedTo: "${withAssignedTo}"` : ''}
        ${withSharedUUID ? `, sharedUUID: "${withSharedUUID}"` : ''}
   ) {
        ${count ? 'count' : ''}
        ${withInfo ? orderInfoQuery() : ''}
        ${withHistory ? orderHistoryQuery() : ''}
      }
    }`
}

export const orderByIdQuery = ({ orderId }) => {
  return `{
      orderById(orderId: "${orderId}") {
        unit
        ${orderItemsQuery()}
      }
  }`
}

const rootMediaQuery = `
 medias {
   id
   name
   thumbnail
   preview
   node {
     id
     paths
   }
   addedAt
   restriction {
     type
   }
 }`

export const mediaDetailsQuery = id => {
  return `{media(
    id: "${id}") {
      restriction {
        email
        type
        message
      }
      groups
      relativePath
      resources {
        type
        values
      }
      metaData {
        dpi
        height
        width
        clippingPath
        caption
      }
      node {
        id
        groups
        paths
      },
      uploader {
        email
        firstname
        lastname
      }
    }
  }`
}

export const mediaByNodeQuery = ({ sortType, limit, skip, node, listType }) => {
  return `{
    mediaByNode(sortType: ${sortType}, skip: ${skip}, limit: ${limit}, node: "${node}", listType: ${listType}){
      count,
      ${rootMediaQuery}
    }
  }`
}

export const mediaSearchQuery = ({
  sortType,
  criteria,
  skip,
  limit,
  count = true
}) => {
  return `{
      mediaBySearch(sortType: ${sortType}, criteria: "${criteria.trim()}", skip: ${skip}, limit: ${limit}, extended: false) {
        ${count ? 'count' : ''}
        ${rootMediaQuery}
      }
    }`
}



// WEBPACK FOOTER //
// ./src/utils/queries.js